import { render, staticRenderFns } from "./SiatNotificheListaPage.vue?vue&type=template&id=eda599bc&scoped=true"
import script from "./SiatNotificheListaPage.vue?vue&type=script&lang=js"
export * from "./SiatNotificheListaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda599bc",
  null
  
)

export default component.exports